import { CREATE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES } from '../types';
import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  createWatchListEntry,
  createWatchListEntryPending,
  createWatchListEntryFulfilled,
  createWatchListEntryRejected,
} = createAsyncActions(CREATE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES, 'createWatchListEntry');


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/actions/createWatchListEntryActions.js